import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', (event) => {
		const sliderElements = document.querySelectorAll<HTMLDivElement>(
			'[data-ambassador-slider-container]',
		)

		if (sliderElements.length > 0) {
			sliderElements.forEach((el) => {
				const sliderEl = el.querySelector<HTMLDivElement>('[data-ambassador-slider]')
				const controlsParent = el.querySelector<HTMLDivElement>('[data-ambassador-slider]')

				if (!sliderEl) return
				new Swiper(sliderEl, {
					spaceBetween: '24px',
					slidesPerView: 'auto',
					modules: [Navigation],
					speed: 500,
					navigation: {
						nextEl: '[data-swiper-button-next]',
						prevEl: '[data-swiper-button-prev]',
					}
				})
			})
		}
	})
}
